import React, {useEffect, useState} from 'react';

import { Button } from 'components/commons';
import FormModalItem from "../FeedModalItem";
import type { IFeedOptionsFilters, IFeedOptionsFrequency, IFeedOptionsMarkets } from "api/services/feed/types";
import { IFormFeedData } from 'redux/feeds/types';
import {useDispatch} from "react-redux";
import {createPostFeed} from 'redux/feeds/actions';

export interface IFeedFormProps {
  feeds: IFormFeedData[] | [],
  setFeedData: React.Dispatch<React.SetStateAction<IFormFeedData[] | []>>,
  markets: IFeedOptionsMarkets[] | [],
  filters: IFeedOptionsFilters[] | [],
  frequency: IFeedOptionsFrequency[] | [],
  sellerId: number,
  userId: string,
  updateFeedDataHandler: (data: IFormFeedData) => void,
  deleteFeedHandler: (id: number) => void,
  restoreFeedHandler: (id: number) => void
}


const FeedForm: React.FC<IFeedFormProps> = ({
  feeds,
  setFeedData,
  markets,
  filters,
  frequency,
  sellerId,
  updateFeedDataHandler,
  deleteFeedHandler,
  restoreFeedHandler,
}) => {

  const dispatch = useDispatch();

  const [feedToCreate, setFeedToCreate] = useState<IFormFeedData | null>(null);
  const [isDeletedFilter, setIsDeletedFilter] = useState<boolean>(false);
  const [filteredItems, setFilterItems] = useState<IFormFeedData[]>([...feeds]);

  const addFeedFormHandler = () => {
    const initialFeedData: IFormFeedData = {
      sellerId: sellerId,
      title: "",
      marketId: 'GENERAL',
      isActive: true,
      isDeleted: false,
      filterId: null,
      frequency: 0,
      generatedAt: '',
      generatedPIDs: [],
      warehouse: "",
      stocksSourceWhID: "",
      isUpdatePrices: true,
      isUpdateStocks: true,
      isUpdateAttributes: true,
      url: null
    }
    setFeedToCreate(initialFeedData);
  }

  const saveNewFeedHandler = (data: IFormFeedData) => {
    setFeedToCreate(null);
    dispatch(createPostFeed(data) as any);

  }

  const cancelNewFeedHandler = () => {
    setFeedToCreate(null);
  }

  const changeFormData = (data: IFormFeedData) => {
    updateFeedDataHandler(data);
  }

  useEffect(() => {
    filterItems(isDeletedFilter)
  }, [isDeletedFilter, feeds]);

  function filterItems(isDeletedFilter: boolean) {
    const filtered = feeds.filter(p => p.isDeleted === isDeletedFilter);
    setFilterItems([...filtered]);
  }

  return (
    <div className='relative'>
      <div className='pt-2 pb-4 px-4 flex flex-col bg-white'>
        <div className='mb-2 self-end'>
          <Button data-testid="button-add-feed" disabled={feedToCreate ? true : false} clickHandler={addFeedFormHandler} appearance='primary'>+ Добавить фид</Button>
        </div>
        <div>
          <ul className="contact-list">
            {isDeletedFilter ?
                <li className="pb-[8px]">
                  <a className="style_tabLink pr-[20px] mr-4 pb-[8px] text-[#64748B]" onClick={() => setIsDeletedFilter(false)} href="#">Активные</a>
                </li>
                :
                <li className="pb-[8px]">
                  <span className="style_tabLink pr-[20px] mr-4 pb-[8px] text-[#64748B]" aria-selected="true" >Активные</span>
                </li>
            }
            {isDeletedFilter
                ?
                <li className="pb-[8px]">
                  <span className="style_tabLink pr-[20px] mr-4 pb-[8px] text-[#64748B]" aria-selected="true" >Архив</span>
                </li>
                :
                <li className="pb-[8px]">
                  <a className="style_tabLink pr-[20px] mr-4 pb-[8px] text-[#64748B]"  onClick={() => setIsDeletedFilter(true)} href="#">Архив</a>
                </li>
            }
          </ul>
          <div>
            {
                feedToCreate &&
                <FormModalItem
                    preExpand={true}
                    data-testid="created-feed-modal-item"
                    markets={markets}
                    filters={filters}
                    frequency={frequency}
                    feedData={feedToCreate}
                    changeFormData={saveNewFeedHandler}
                    cancelChanging={cancelNewFeedHandler}
                />
            }

            {
                filteredItems && filteredItems.map((item, i) => (
                    <div key={item.id} className='mt-4'>
                      <FormModalItem
                          markets={markets}
                          filters={filters}
                          frequency={frequency}
                          feedData={item}
                          changeFormData={changeFormData}
                          deleteFeedHandler={deleteFeedHandler}
                          restoreFeedHandler={restoreFeedHandler}
                      />
                    </div>
                ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedForm;